import { useSelector } from "react-redux";
import AddPractice from "../Admin/Practice/AddPractice";
import AddNewLocBody from "../Admin/Location/AddNewLocBody";
import AddNewLocation from "../../Setup/Account/Location/AddNewLocation";
import AddNewBillingProvider from "../../Setup/Account/BillingProvider/AddNewBillingProvider";
import AddNewProvider from "../../Setup/Account/Provider/AddNewProvider";
import AddNewRefProvider from "../../Setup/Account/RefProvider/AddNewRefProvider"
import Statement from "../../Setup/Account/Statement/Statement";
import AddNewPractice from "../../Setup/Account/Practice/AddNewPractice";
// import Services from "../../Setup/Account/Services/Services";
import AddNewInsurance from "../../Setup/InsuranceM/Insurance/AddNewInsurance";
import AddNewInsuranceTypeCode from "../../Setup/InsuranceM/InsuranceType/AddNewInsuranceTypeCode";
import AddNewInsuranceCategory from "../../Setup/InsuranceM/InsurranceCategory/AddNewInsurranceCategory";
import AddNewSubmitter from "../../Setup/InsuranceM/Submitter/AddNewSubmitter";
import AddNewPOS from "../../Setup/Coding/POS/AddNewPOS";
import AddNewDiagnosis from "../../Setup/Coding/DiagnosisCode/AddNewDiagnosis";
import AddNewProcedureCodes from "../../Setup/Coding/ProcedureCode/AddNewProcedureCodes";
import ProcedureMacros from "../../Setup/Coding/ProcedureMacro/AddnewProcedureMacro";
import AddNewRevenueCodes from "../../Setup/Coding/RevenueCodes/AddNewRevenueCodes";
import AddNewModifier from "../../Setup/Coding/Modifiers/AddNewModifier";
import Location from "../../Setup/Account/Location/Location";
import Provider from "../../Setup/Account/Provider/Provider";
import RefProvider from "../../Setup/Account/RefProvider/RefProvider";
import BillingProvider from "../../Setup/Account/BillingProvider/BillingProvider";
import Insurance from "../../Setup/InsuranceM/Insurance/Insurance";
import InsuranceTypeCode from "../../Setup/InsuranceM/InsuranceType/InsuranceTypeCode";
import InsurranceCategory from "../../Setup/InsuranceM/InsurranceCategory/InsurranceCategory";
import Submitter from "../../Setup/InsuranceM/Submitter/Submitter";
import POS from "../../Setup/Coding/POS/POS";
import DiagnosisCodes from "../../Setup/Coding/DiagnosisCode/DiagnosisCodes";
import ProcedureCodes from "../../Setup/Coding/ProcedureCode/ProcedureCodes";
import ProcedureMacro from "../../Setup/Coding/ProcedureMacro/ProcedureMacro";
import RevenueCodes from "../../Setup/Coding/RevenueCodes/RevenueCodes";
import Modifier from "../../Setup/Coding/Modifiers/Modifiers";
const WizardMenu = () => {
    let DropDowns  = useSelector(state => state.GeneralDropDownsReducer);
    return [
        {
            name: 'Admin',
            key: 7860,
            icon: "",
            right: true,
            subCategoryItems: [
                {
                    name: 'Practice Info',
                    key: 7861,
                    icon: "",
                    className:"pract_info",
                    component: <AddNewPractice />,
                    right: true,
                    isFilled: DropDowns && DropDowns?.Practice?.length > 0 ? 'true' : 'false'
                },
                {
                    name: 'Location',
                    key: 7862,
                    icon: "",
                    className:"loc",
                    component: <Location type={'Wizard'}/>,
                    // component: <AddNewLocation type={'Wizard'}/>,
                    right: true,
                    isFilled: DropDowns && DropDowns?.Location?.length > 1 ? 'true' : 'false'
                },
                {
                    name: 'Provider',
                    key: 7863,
                    icon: "",
                    className:"pro",
                    component: <Provider type={'Wizard'}/>,
                    right: true,
                    isFilled: DropDowns && DropDowns?.Provider?.length > 1 ? 'true' : 'false'
                },
                {
                    name: 'Ref. Provider',
                    key: 7864,
                    icon: "",
                    className:"ref",
                    component: <RefProvider type={"Wizard"} />,
                    right: true,
                    isFilled: DropDowns && DropDowns?.RefProvider?.length > 1 ? 'true' : 'false'
                },
                {
                    name: 'Billing Provider',
                    key: 7865,
                    icon: "",
                    className:"billing",
                    component: <BillingProvider type="Wizard" />,
                    right: true,
                    isFilled: DropDowns && DropDowns?.BillingProvider?.length > 1 ? 'true' : 'false'
                },
                {
                    name: 'POS',
                    key: 7866,
                    icon: "",
                    className:"pos",
                    component: <POS type={"Wizard"} />,
                    right: true,
                    isFilled:  DropDowns && DropDowns?.POS?.length > 1 ? 'true' : 'false'
                },
                // {
                //     name: 'Services',
                //     key: 7867,
                //     icon: "",
                //     component: <Services />,
                //     right: true,
                //     isFilled: DropDowns && DropDowns?.Services
                // },
            ]
        },
        {
            name: 'Insurance',
            key: 78600,
            icon: "",
            right: true,
            subCategoryItems: [
                {
                    name: 'Insurance',
                    key: 78601,
                    icon: "",
                    className:"ins",
                    component: <Insurance type={"Wizard"} />,
                    right: true,
                    isFilled: DropDowns && DropDowns?.Insurance?.length > 1 ? 'true' : 'false'
                },
                // {
                //     name: 'Insurance Type',
                //     key: 78602,
                //     icon: "",
                //     className:"ins_type",
                //     component: <InsuranceTypeCode type={"Wizard"} />,
                //     right: true,
                //     isFilled: DropDowns && DropDowns?.InsuranceType
                // },
                // {
                //     name: 'Insurance Category',
                //     key: 78603,
                //     icon: "",
                //     className:"ins_cat",
                //     component: <InsurranceCategory type={"Wizard"} />,
                //     right: true,
                //     isFilled: DropDowns && DropDowns?.InsuranceCategory
                // },
                {
                    name: 'Reciever Setup',
                    key: 78602,
                    icon: "",
                    component: <Submitter type={"Wizard"} />,
                    right: true,
                    isFilled: DropDowns && DropDowns?.Submitter
                }
            ]
        },

        {
            name: 'Billing Codes',
            key: 78610,
            icon: "",
            right: true,
            subCategoryItems: [
                // {
                //     name: 'POS',
                //     key: 78611,
                //     icon: "",
                //     className:"pos",
                //     component: <POS type={"Wizard"} />,
                //     right: true,
                //     isFilled: DropDowns && DropDowns?.POS?.length > 1 ? 'true' : 'false'
                // },
                {
                    name: 'ICD ',
                    key: 78611,
                    icon: "",
                    className:"diagnosis",
                    component: <DiagnosisCodes type={"Wizard"} />,
                    right: true,
                    isFilled: DropDowns && DropDowns?.Diagnosis
                },
                {
                    name: 'CPT',
                    key: 78612,
                    icon: "",
                    className:"procedure",
                    component: <ProcedureCodes type={"Wizard"} />,
                    right: true,
                    isFilled: DropDowns && DropDowns?.Procedures
                },
                // {
                //     name: 'Procedure Macro',
                //     key: 78614,
                //     icon: "",
                //     className:"procedure_macro",
                //     component: <ProcedureMacro  type={"Wizard"}/>,
                //     right: true,
                //     isFilled: DropDowns && DropDowns?.ProcedureMacro
                // },
                // {
                //     name: 'Revenue ',
                //     key: 78615,
                //     icon: "",
                //     className:"revenue",
                //     component: <RevenueCodes  type={"Wizard"}/>,
                //     right: true,
                //     isFilled: DropDowns && DropDowns?.Revenue
                // },
                {
                    name: 'Modifiers',
                    key: 78613,
                    icon: "",
                    component: <Modifier type={"Wizard"} />,
                    right: true,
                    isFilled: DropDowns && DropDowns?.Modifiers
                },
                // {
                //     name: 'EDI Codes',
                //     key: 636,
                //     icon: "",
                //     // component: '',
                //     right: true,
                //     isFilled: 'false',
                //     subCategoryItems1: [
                //         {
                //             name: 'Category Code',
                //             key: 6361,
                //             icon: "",
                //             component: <CategoryCode />,
                //             right: true,
                //         },
                //         {
                //             name: 'Status Code',
                //             key: 6362,
                //             icon: "",
                //             component: <StatusCode />,
                //             right: true,
                //         },
                //         {
                //             name: 'Adjustment',
                //             key: 6363,
                //             icon: "",
                //             component: <AdjustmentCodes />,
                //             right: true,
                //         },
                //         {
                //             name: 'Remark',
                //             key: 6364,
                //             icon: "",
                //             component: <RemarkCodes />,
                //             right: true,
                //         },
                //         {
                //             name: 'Denial Group',
                //             key: 6365,
                //             icon: "",
                //             component: <DeniedCode />,
                //             right: true,
                //         },
                //     ]
                // },
                // {
                //     name: 'Institutional  Tab',
                //     key: 639,
                //     icon: "",
                //     // component: <InstitutionalCodesTab/>,
                //     right: true,
                //     isFilled: 'false',
                //     subCategoryItems2: [
                //         {
                //             name: 'DRG Code',
                //             key: 6391,
                //             icon: "",
                //             component: <DrgCode />,
                //             right: true,
                //         },
                //         {
                //             name: 'Condition Code',
                //             key: 6392,
                //             icon: "",
                //             component: <ConditionCode />,
                //             right: true,
                //         },
                //         {
                //             name: 'Value Code',
                //             key: 6393,
                //             icon: "",
                //             component: <ValueCode />,
                //             right: true,
                //         },
                //         {
                //             name: 'Occurrence Span',
                //             key: 6394,
                //             icon: "",
                //             component: <OccurrenceSpan />,
                //             right: true,
                //         },
                //         {
                //             name: 'Occurrence Code',
                //             key: 6395,
                //             icon: "",
                //             component: <OccurrenceCode />,
                //             right: true,
                //         },
                //     ]
                // },
            ]
        },
        
        
       
    ]
}

export default WizardMenu
